import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=1cde3d05&scoped=true"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde3d05",
  null
  
)

export default component.exports